class Urls {
    constructor(urlBase) {
        let baseUrl = urlBase + 'api/';
        this.baseUrl = baseUrl;
        this.linkUrl = urlBase + 'link/';
        this.frontendUrl = 'https://dictionary.lexillon.co.il/';

        this.user = {
            login: baseUrl + "users/login",
            logout: baseUrl + "users/logout",
            verifyToken: baseUrl + "users/verify-token",
            getOne: baseUrl + "users/user",
            getAll: baseUrl + "users",
            getAllWithPagination: baseUrl + "users/pagination",
            getGoalWithPagination: baseUrl + "users/goal-pagination",
            getGoalUserWithPagination: baseUrl + "users/goal-user-pagination",
            update: baseUrl + 'users',
            verifyCaptcha: baseUrl + "users/verify-captcha",
            loginWithGoogle: baseUrl + "users/auth/google", // Google login
            loginWithMinistryOfEducation: baseUrl + "users/auth/ministry-of-education", // Ministry of Education login
            logoutMinistryOfEducation: baseUrl + "users/logout-ministry-of-education", // Ministry of Education logout
        }

        this.accessSerial = {
            getAllWithPagination: baseUrl + "access-serial/pagination",
            add: baseUrl + "access-serial/",
            update: baseUrl + "access-serial",
            delete: baseUrl + "access-serial",
            apply: baseUrl + "access-serial/apply/",
            revoke: baseUrl + "access-serial/revoke",
        };

        this.permissionProfile = {
            getAll: baseUrl + "permission-profile/pagination",
            getPermissionOptions: baseUrl + "permission-profile/get/options",
            create: baseUrl + "permission-profile/",
            update: baseUrl + "permission-profile",
            delete: baseUrl + "permission-profile",
        };

        this.dictionary = {
            dictionary_eng_to_heb: baseUrl + "dictionary/dictionary_eng_to_heb/",
            dictionary_heb_to_eng: baseUrl + "dictionary/dictionary_heb_to_eng/",
            getAdditionalInfo: baseUrl + "dictionary/get-additionalInfo/",
            reloading_ram_memory: baseUrl + "dictionary/ram-memory/reloading-dictionaries/",
        };

        this.categories = {
            category: baseUrl + "category/",
        };

        this.dictionaryLog = {
            getAll: baseUrl + "dictionary-log",
        };

        this.payment = {
            createSubscription_step1: baseUrl + "payment/paypal/subscription/create",
            createSubscription_step2: baseUrl + "payment/paypal/subscription/open",
            cancelSubscription: baseUrl + "payment/paypal/subscription/cancel",
        };

        this.additionalInfo = {
            get: baseUrl + "additional-info/get/",
            add: baseUrl + "additional-info/add",
            update: baseUrl + "additional-info/update",
            delete: baseUrl + "additional-info/",
            clearField: baseUrl + "additional-info/clear-field",
            audioSummary: baseUrl + "additional-info/audio-summary",
            getImages: baseUrl + "additional-info/get-images",
        };

        this.file = {
            getImage: "https://lexillon-files-il.s3.il-central-1.amazonaws.com/files/images-webp/",
        }

        this.ai = {
            create: baseUrl + "ai/create",
            getSettings: baseUrl + "ai/settings/get",
            setSelectedProvider: baseUrl + "ai/settings/set-selected-provider/",
            setSelectedModel: baseUrl + "ai/settings/set-selected-model/",
            setTemperature: baseUrl + "ai/settings/set-temperature/",
            setSelectedPrompt: baseUrl + "ai/settings/set-selected-prompt/",
            createPrompt: baseUrl + "ai/settings/create-prompt",
            updatePrompt: baseUrl + "ai/settings/update-prompt",
            deletePrompt: baseUrl + "ai/settings/delete-prompt/",
            textToSpeechGemini: baseUrl + "ai/text-to-speech/generate-audio-with-prompt",
            audioSettings: baseUrl + "ai/settings/audio", // the settings of the automatic creation of the audio files
            audioSettingsInworld: baseUrl + "ai/settings/audio/inworld", // the settings of Inworld (model, pace, voices)
            audioSettingsAuto: baseUrl + "ai/settings/audio/auto", // the rules of the automatic creation per dictionary and language
            audioFailures: baseUrl + "ai/settings/audio/failures", // the latest failures of the automatic creation
            audioJobs: baseUrl + "ai/audio-jobs", // the bulk audio runs: /options, /plan, start, list, /:id, /:id/items, /:id/stop, /:id/resume
            nakdan: baseUrl + "ai/nakdan",
        }

        this.search = {
            smartSearch: baseUrl + "dictionary/v2/smart-search",
        }

        this.statistics = {
            getRequestStats: baseUrl + "request/request-stats",
            getActiveUsers: baseUrl + "request/active-users",
        };

        this.admin = {
            addUserToGoal: baseUrl + "admin-specific/add-user-to-goal",
            removeUserFromGoal: baseUrl + "admin-specific/remove-user-from-goal",
            getAllGoalsForUser: baseUrl + "admin-specific/get-all-goals-for-user/",
        };

        this.tests = {
            runTest: baseUrl + "tests/run",
            fixTest: baseUrl + "tests/fix",
        };
    }
}

class DevelopmentUrls extends Urls {
    constructor() {
        // super("https://test.lexillon.co.il/api/"); // Test server
        super("http://localhost:3001/"); // Development server
        // כזי להשתמש בכתובת זו יש לגלוש לכתובת זו ולאשר בדפדפן את הגלישה לאתר לא מאובטח
        // super("https://localhost:3001/api/"); // Development server
        this.frontendUrl = 'https://localhost:3002/Classroom';
    }
}

class ProductionUrls extends Urls {
    constructor() {
        super("https://test.lexillon.co.il/"); // Test server
        // super("https://main.lexillon.co.il/api/"); // Production server
        this.linkUrl = "https://main.lexillon.co.il/link/";
    }
}

const urls = process.env.NODE_ENV === "development" ? new DevelopmentUrls() : new ProductionUrls();

export default urls;
